import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from '@yonderland/andes-react';
import { useSelector } from 'react-redux';
import { makeGetPPCForSelectedColorWithId } from '../../../redux/product/selectors/ProductSelector';
import { ProductPlacementCopyBox } from './productPlacementCopyBox';
export const ProductPlacementCopy = ({ ppcType }) => {
    const getPPCPositionsForSelectedColor = makeGetPPCForSelectedColorWithId();
    const items = useSelector((state) => getPPCPositionsForSelectedColor(state, ppcType));
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    return (_jsx(Stack, { direction: "col", gap: "2", testId: "product-placement-copy", children: items.map(item => (_jsx(ProductPlacementCopyBox, { ppc: item }, item.name))) }));
};
